import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.top_up.error.title',
        defaultMessage: 'Top up failed',
    },
    subtitle: {
        id: 'modal.top_up.error.subtitle',
        defaultMessage: 'Unable to complete the transaction. Please try again or contact support.',
    },
    contact: {
        id: 'modal.top_up.error.contact',
        defaultMessage: 'Contact support',
    },
    button: {
        id: 'modal.top_up.error.close',
        defaultMessage: 'Close',
    },
})
